import { createContext, useContext, useState } from 'react';

// Create Context
const DynamicRoutingValidationContext = createContext();

// Provider Component
export const DynamicRoutingValidationProvider = ({ children }) => {
  const [shipmentUpdates, setShipmentUpdates] = useState({
    incorrectPse: new Set(),
    lateShipments: new Set()
  });

  const [excludedPros, setExcludedPros] = useState(new Set());

  // Function to add a proId to a specific category
  const addShipmentUpdate = (proIdList, section) => {
    setShipmentUpdates((prevState) => ({
      ...prevState,
      [section]: new Set([...prevState[section], ...proIdList])
    }));
  };

  // Function to toggle pro (Add or Remove)
  const toggleExcludedPro = (proId, isInclude) => {
    setExcludedPros((prevSet) => {
      const newSet = new Set(prevSet);
      isInclude ? newSet.delete(proId) : newSet.add(proId);
      return newSet; // Always return a new Set to trigger re-render
    });
  };

  return (
    <DynamicRoutingValidationContext.Provider
      value={{ shipmentUpdates, addShipmentUpdate, excludedPros, toggleExcludedPro }}>
      {children}
    </DynamicRoutingValidationContext.Provider>
  );
};

// Custom Hook for easy access
export const useDynamicRoutingValidationContext = () => useContext(DynamicRoutingValidationContext);
